import type { Profession, ProfessionDef } from '@/types/domain';

/* Profession → allowed title prefixes + suffixes (locked spec).
   Drives the onboarding title fields. Rendered as `{prefix} {name} {suffix}`.
   A user's profession is fixed by their invite and read-only at onboarding. */
export const professions: Record<Profession, ProfessionDef> = {
  DOCTOR: {
    id: 'DOCTOR',
    label: { en: 'Doctor', th: 'แพทย์' },
    prefixes: [
      { en: 'Dr.', th: 'นพ.' },
      { en: 'Dr.', th: 'พญ.' },
    ],
    suffixes: [],
  },
  DENTIST: {
    id: 'DENTIST',
    label: { en: 'Dentist', th: 'ทันตแพทย์' },
    prefixes: [
      { en: 'Dr.', th: 'ทพ.' },
      { en: 'Dr.', th: 'ทพญ.' },
    ],
    suffixes: [],
  },
  PHARMACIST: {
    id: 'PHARMACIST',
    label: { en: 'Pharmacist', th: 'เภสัชกร' },
    prefixes: [
      { en: '', th: 'ภก.' },
      { en: '', th: 'ภญ.' },
    ],
    suffixes: [],
  },
  NURSE: {
    id: 'NURSE',
    label: { en: 'Nurse', th: 'พยาบาล' },
    prefixes: [
      { en: '', th: 'พว.' },
    ],
    suffixes: ['RN', 'ENP'],
  },
  PARAMEDIC: {
    id: 'PARAMEDIC',
    label: { en: 'Paramedic', th: 'นักปฏิบัติการฉุกเฉินการแพทย์' },
    prefixes: [
      { en: '', th: 'นาย' },
      { en: '', th: 'นาง' },
      { en: '', th: 'นางสาว' },
    ],
    suffixes: ['Paramedic'],
  },
  'A-EMT': {
    id: 'A-EMT',
    label: { en: 'A-EMT', th: 'เวชกรฉุกเฉิน' },
    prefixes: [
      { en: '', th: 'นาย' },
      { en: '', th: 'นาง' },
      { en: '', th: 'นางสาว' },
    ],
    suffixes: ['A-EMT'],
  },
};

export const PROFESSION_IDS = Object.keys(professions) as Profession[];
